export const getTimeZones = (state) => state.timeZones